export const getRadioGroupOverrides = () => {
  return {
    MuiFormControlLabel: {
      styleOverrides: {
        root: {
          marginLeft: 0,
          marginRight: 0
        }
      }
    },
    MuiButtonBase: {
      styleOverrides: {
        root: {
          "&.DropdownCheck": {
            padding: 9
          }
        }
      }
    }
  };
};